import {
  GET_SEASONS,
  GET_CURRENT_SEASON,
  CREATE_SEASON,
  UPDATE_SEASON,
  DELETE_SEASON,
  SET_CURRENT_SEASON,
  GET_SEASON_STATS,
  SEASON_ERROR,
  CLEAR_SEASON_ERROR
} from '../types';

export default (state, action) => {
  switch (action.type) {
    case GET_SEASONS:
      return {
        ...state,
        seasons: action.payload,
        loading: false
      };
    case GET_CURRENT_SEASON:
      return {
        ...state,
        currentSeason: action.payload,
        loading: false
      };
    case CREATE_SEASON:
      return {
        ...state,
        seasons: [action.payload, ...state.seasons],
        loading: false
      };
    case UPDATE_SEASON:
      return {
        ...state,
        seasons: state.seasons.map(season =>
          season._id === action.payload._id ? action.payload : season
        ),
        currentSeason: state.currentSeason?._id === action.payload._id 
          ? action.payload 
          : state.currentSeason,
        loading: false
      };
    case SET_CURRENT_SEASON:
      return {
        ...state,
        currentSeason: action.payload,
        seasons: state.seasons.map(season =>
          season._id === action.payload._id 
            ? { ...season, isCurrent: true }
            : { ...season, isCurrent: false }
        ),
        loading: false
      };
    case DELETE_SEASON:
      return {
        ...state,
        seasons: state.seasons.filter(season => season._id !== action.payload),
        loading: false
      };
    case GET_SEASON_STATS:
      return {
        ...state,
        seasonStats: action.payload,
        loading: false
      };
    case SEASON_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    case CLEAR_SEASON_ERROR:
      return {
        ...state,
        error: null
      };
    default:
      return state;
  }
};